import { render, staticRenderFns } from "./followUpRecord.vue?vue&type=template&id=37a90572&scoped=true&"
import script from "./followUpRecord.vue?vue&type=script&lang=js&"
export * from "./followUpRecord.vue?vue&type=script&lang=js&"
import style0 from "./followUpRecord.vue?vue&type=style&index=0&id=37a90572&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a90572",
  null
  
)

export default component.exports